import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import "./subscribe.scss";

function Subscriptions() {
  const buttonRef = useRef();
  const [subscriptionDetails, setSubscriptionDetails] = useState([]);

  const query = useHistory().location.search;
  const token = new URLSearchParams(query).get("token");
  const customerId = new URLSearchParams(query).get("customerId");
  const subscriptionId = new URLSearchParams(query).get("subscriptionId");
  const action = new URLSearchParams(query).get("action");

  useEffect(() => {
    if (!customerId && !subscriptionId) {
      fetch(`${process.env.REACT_APP_API_URL}/subscription?token=${token}`)
        .then((res) => res.json())
        .then((response) => {
          setSubscriptionDetails({
            customerId: response.data.customerUniqueId,
            subscriptionId: response.data.subscriptionUniqueId,
          });
        })
        .catch((error) => {
          console.log(error.message);
        });
    }
    setTimeout(() => {
      buttonRef.current.click();
    }, 2000);
  }, []);

  return (
    <div className="d-flex  ">
      <div className="flex-1 p-4">
        <div className="application">
          <Helmet>
            <script
              src="https://checkoutlib.billsby.com/checkout.min.js"
              data-billsby-company="nimble"
            ></script>
          </Helmet>
          Please click on subscribe button to upgrade your plan{"      "}
          <button
            className="subscribe-btn"
            href="javascript:void(0)"
            data-billsby-type="account"
            data-billsby-customer={customerId ?? subscriptionDetails.customerId}
            data-billsby-subscription={
              subscriptionId ?? subscriptionDetails.subscriptionId
            }
            data-billsby-action={action ?? "paymentdetails"}
            onClick={() => console.log("clicked")}
            ref={buttonRef}
            data-telemetry="Subscribe"
          >
            Subscribe
          </button>
        </div>
      </div>
    </div>
  );
}

export default Subscriptions;
